export const LOAD_RECURRING_INVOICES = 'LOAD_RECURRING_INVOICES'
export const LOAD_RECURRING_STATUS = 'LOAD_RECURRING_STATUS'
export const LOAD_RECURRING_FREQUENCIES = 'LOAD_RECURRING_FREQUENCIES'
export const LOAD_RECURRING_LIMITS = 'LOAD_RECURRING_LIMITS'
